/* Copyright (C) 2018-2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
import { RouteComponentProps } from 'react-router-dom';
// 2. Store and Types. 

export default interface IDashletProps extends RouteComponentProps<any>
{
	ID               : string;
	TITLE            : string;
	SETTINGS_EDITVIEW: any;
	DEFAULT_SETTINGS : any;
	COLUMN_WIDTH     : number  ; // bootstrap 1 to 12. 
}

